import { Box, Flex, Spacer, Text } from "@chakra-ui/react";
import { LOGO_FONT_SIZE, SPACING } from "../constants/Constants";

export default function Footer() {
    return (
        <Box position={"fixed"} bottom={0} w={"100%"} bg={"teal.900"} p={2}>
            <Flex>
                <Text
                    userSelect={"none"}
                    fontWeight={"bold"}
                    fontSize={LOGO_FONT_SIZE / 2}
                    fontFamily={'heading'}
                >
                    © 2022 Code F AB, All Rights Reserved.
                </Text>
                <Spacer />
                <Text mr={SPACING / 4}>
                    Contact us at:
                </Text>
                <Text textDecoration={"underline"}>
                    <a href="mailto:codefab.dev@gmail.com">codefab.dev@gmail.com</a>
                </Text>
            </Flex>
        </Box>
    )
}

